export type PackageType =
  | 'std_pallets'
  | 'pallets_non_std'
  | 'bags'
  | 'bales'
  | 'boxes'
  | 'bunches'
  | 'carpets'
  | 'coils'
  | 'crates'
  | 'cylinders'
  | 'custom'
  | 'drums'
  | 'pails'
  | 'reels'
  | 'rolls'
  | 'tubes_pipes'
  | 'tubes'
  | 'pipes'
  | 'loose'
  | 'pallets'
  | 'plates'
  | 'sheets'

export const packageTypeLabelsMap = new Map<PackageType, string>([
  ['std_pallets', 'Standard Pallets (48x40)'] as const,
  ['pallets_non_std', 'Pallets Non Standard'] as const,
  ['bags', 'Bags'] as const,
  ['bales', 'Bales'] as const,
  ['boxes', 'Boxes'] as const,
  ['bunches', 'Bunches'] as const,
  ['carpets', 'Carpets'] as const,
  ['coils', 'Coils'] as const,
  ['crates', 'Crates'] as const,
  ['cylinders', 'Cylinders'] as const,
  ['drums', 'Drums'] as const,
  ['pails', 'Pails'] as const,
  ['reels', 'Reels'] as const,
  ['rolls', 'Rolls'] as const,
  ['tubes_pipes', 'Tubes and Pipes'] as const,
  ['tubes', 'Tubes'] as const,
  ['pipes', 'Pipes'] as const,
  ['loose', 'Loose'] as const,
  ['plates', 'Plates'] as const,
  ['sheets', 'Sheets'] as const,
])

export type WeightType = 'all_packages' | 'per_package'
